import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from '../../model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';
import { NowMobileLandingCollection } from './models/mobile-landing';
import { NowDataUsageCollection } from './models/data-usage';
import { NowXMUpgrade } from './models/upgrade';

@Injectable()
export class NowMobileLandingApi {
    public static getNowMobileLandingData(_xmStore: XmStore, http: HttpClient): Observable<NowMobileLandingCollection> {
        return http.get('/now/mobile/landing', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY  })
        }).pipe(
            map((response: NowMobileLandingCollection) => NowMobileLandingCollection.create<NowMobileLandingCollection>(response))
        );
    }

    public static getNowDataUsageCollection(_xmStore: XmStore, http: HttpClient): Observable<NowDataUsageCollection> {
        return http.get('/now/usage', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY  })
        }).pipe(
            map((response: NowDataUsageCollection) => NowDataUsageCollection.create<NowDataUsageCollection>(response))
        );
    }

    public static getNowXmUpgradeData(_xmStore: XmStore, http: HttpClient): Observable<NowXMUpgrade> {
        return http.get('/now/mobile/upgrade/xm', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY  })
        }).pipe(
            map((response: NowXMUpgrade) => NowXMUpgrade.create<NowXMUpgrade>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_NOW_MOBILE_LANDING] = NowMobileLandingApi.getNowMobileLandingData;
ModelBase.fetchMapping[StoreAction.GET_NOW_DATA_USAGE] = NowMobileLandingApi.getNowDataUsageCollection;
ModelBase.fetchMapping[StoreAction.GET_NOW_XM_UPGRADE_DATA] = NowMobileLandingApi.getNowXmUpgradeData;
